import Vue from "vue";
import { Component, Emit, Prop } from "vue-property-decorator";

@Component
export default class FilterYear extends Vue {
  @Prop({ default: "Project Year" }) label!: string;
  get currentYear(): number {
    return this.$store.state.Common.currentYear;
  }
  get year(): number {
    return this.$store.state.Common.year;
  }

  set year(year: number) {
    this.$store.commit("Common/setYear", year);
    this.$router.push({
      path: this.$route.path,
      query: { year: year.toString() },
    });
    this.changeYear();
  }

  public mounted(): void {
    const year = this.$route.query["year"];
    // console.log("year", year, this.$store.state.Common.year, this.$route.query['year']);
    if (year) {
      this.$store.state.Common.year = this.$route.query["year"];
      this.changeYear();
    } else {
      // this.$router.push({
      //   path: this.$route.path,
      //   query: { year: this.$store.state.Common.year + 1 },
      // });
    }
  }

  @Emit("changeYear")
  public changeYear(): null {
    return null;
  }
}
